function xor(propType) {
  for (var _len = arguments.length, otherPropNames = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    otherPropNames[_key - 1] = arguments[_key];
  }
  return function (props, propName, componentName) {
    if (props[propName] != null) {
      var otherProps = otherPropNames.map(function (name) {
        return props[name];
      }).filter(function (prop) {
        return prop != null;
      });
      if (otherProps.length > 0) {
        return new Error("Invalid prop `".concat(propName, "` supplied to `").concat(componentName, "`: expected only one of ") + "".concat([propName].concat(otherPropNames).map(function (name) {
          return "`".concat(name, "`");
        }).join(', '), " to be set."));
      }
    }
    return propType.apply(null, arguments);
  };
}
export default xor;
export { xor };